import styled from 'styled-components';

import fonts from 'apps/promo/theme/fonts';
import media from 'apps/promo/theme/media';
import promoColors from 'apps/promo/theme/promoColors';
import zIndex from 'apps/promo/theme/zIndex';

export const SearchWrapper = styled.div`
    position: relative;
`;
export const SearchDropdown = styled.div`
    background-color: ${promoColors.white};
    border: 1px solid ${promoColors.gray20};
    padding: 8px 0;
    border-radius: 8px;
    position: absolute;
    z-index: ${zIndex.landingDropdown};
    width: 100%;
    overflow: auto;
    max-height: 300px;
    min-height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: ${(props) => (props.centerAligned ? 'center' : null)};
`;
export const SearchDropdownItem = styled.a`
    display: block;
    cursor: pointer;
    padding: 12px 16px;

    &:hover {
        background-color: ${promoColors.gray5};
    }
`;

export const MobileTextComponent = styled.div`
    padding-bottom: 40px;

    span {
        font-family: ${fonts.gtStandardMMedium} !important;
    }

    strong {
        font-family: ${fonts.gtStandardMBold};
    }

    img {
        max-width: 100%;
        border: none;
        height: auto;

        ${media.desktop1920} {
            max-width: 704px;
        }
    }

    p + p,
    p + figure,
    p + ul,
    p + ol {
        margin-top: 1em;
    }

    h1,
    h2,
    h3,
    h4 {
        margin-bottom: 1em;
        margin-top: 1em;
    }

    h1 {
        font-size: 24px;
        line-height: 40px;
    }

    h2 {
        font-size: 20px;
        line-height: 32px;
    }

    /* gray text subheader */
    h3 {
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: ${(props) => props.theme.grey_72_lc};
        padding: 16px 0;
    }

    h3 strong {
        font-weight: normal;
        font-family: ${fonts.gtStandardMMedium};
    }

    h4 {
        font-size: 17px;
        line-height: 24px;
    }

    ol {
        list-style-type: decimal;
        ol {
            counter-reset: item;
            list-style-type: none;

            li {
                margin-left: 30px;

                &::before {
                    counter-increment: item;
                    content: counter(item, lower-alpha) ') ';
                    left: -16px;
                    position: absolute;
                    top: 6px;
                }
            }
        }
    }

    ol,
    ul {
        li {
            margin-bottom: 16px;
            margin-left: 32px;
            position: relative;
            padding: 0 !important;
        }
    }

    ul li {
        list-style: disc outside;
    }

    blockquote {
        padding-top: 40px;
        position: relative;

        &::before {
            background: transparent
                url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTEwLjkyMzYgMTQuMzgzNEwxMy40MDY2IDguNDI0MjFDMTMuNjg4OSA3Ljc0NjY5IDEzLjE5MTEgNyAxMi40NTcxIDdDMTIuMTY2MSA3IDExLjg4ODcgNy4xMjMyNyAxMS42OTM2IDcuMzM5MjZMNC45MjY1OCAxNC44MzM3QzEuNzM5NDEgMTguMzYzNSA0LjI0NDIyIDI0ICA4Ljk5OTk5IDI0IEMxMS43NjE0IDI0IDE0IDIxLjc2MTQgMTQgMTlDMTQgMTYuOTIwMiAxMi43MzAyIDE1LjEzNyAxMC45MjM2IDE0LjM4MzRaTTIzIDI0QzE4LjI0NDIgMjQgMTUuNzM5NCAxOC4zNjM1IDE4LjkyNjYgMTQuODMzN0wyNS42OTM2IDcuMzM5MjZDMjUuODg4NyA3LjEyMzI3IDI2LjE2NjEgNyAyNi40NTcxIDdDMjcuMTkxMSA3IDI3LjY4ODkgNy43NDY2OSAyNy40MDY2IDguNDI0MjFMMjQuOTIzNiAxNC4zODM0QzI2LjczMDIgMTUuMTM3IDI4IDE2LjkyMDIgMjggMTlDMjggMjEuNzYxNCAyNS43NjE0IDI0IDIzIDI0WiIgZmlsbD0iIzE0MTQxNCIvPjwvc3ZnPg==')
                no-repeat center scroll;
            content: '';
            height: 32px;
            left: 0;
            position: absolute;
            top: 0;
            width: 32px;
        }
    }

    a {
        color: ${(props) => props.theme.purple_100} !important;
        text-decoration: underline !important;

        &:hover {
            color: ${(props) => props.theme.purple_72_lc} !important;
        }
    }

    ${media.desktop1920} {
        h1 {
            font-size: 40px;
            line-height: 64px;
        }

        h2 {
            font-size: 28px;
            line-height: 48px;
        }

        /* gray text subheader */
        h3 {
            font-size: 17px;
            line-height: 24px;
            padding: 24px 0;
        }

        h4 {
            font-size: 20px;
            line-height: 32px;
        }

        ul,
        ol {
            margin-bottom: 24px;

            li {
                margin-bottom: 24px;
                margin-left: 48px;
            }
        }
    }
`;

export const VoteBlock = styled.div`
    border-top: 1px solid ${(props) => props.theme.grey_28_tr};
    border-bottom: 1px solid ${(props) => props.theme.grey_28_tr};
    padding: 32px 24px;
    margin: 0 -24px 24px -24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    & > div {
        margin-left: 24px;

        button {
            margin-right: 16px;

            &:last-child {
                margin-right: 0;
            }
        }
    }
`;
